// メインスレッド側の Web Worker ラッパ（promise RPC）。
import CalcWorker from './calc.worker?worker';
import type { ComputeOptions } from '../core/engine';
import type { EngineResult, FarmInput } from '../core/types';
import type { Computer } from './computer';

interface Pending {
  resolve: (v: unknown) => void;
  reject: (e: Error) => void;
}

interface ResMsg {
  id: number;
  ok: boolean;
  result?: unknown;
  error?: string;
}

export class CalcClient implements Computer {
  private readonly worker: Worker;
  private seq = 0;
  private readonly pending = new Map<number, Pending>();

  constructor() {
    this.worker = new CalcWorker();
    this.worker.onmessage = (e: MessageEvent) => {
      const msg = e.data as ResMsg;
      const p = this.pending.get(msg.id);
      if (!p) return;
      this.pending.delete(msg.id);
      if (msg.ok) p.resolve(msg.result);
      else p.reject(new Error(msg.error ?? 'worker error'));
    };
  }

  private send<T>(type: string, payload: unknown): Promise<T> {
    const id = ++this.seq;
    return new Promise<T>((resolve, reject) => {
      this.pending.set(id, { resolve: resolve as (v: unknown) => void, reject });
      this.worker.postMessage({ id, type, payload });
    });
  }

  compute(input: FarmInput, opts?: ComputeOptions): Promise<EngineResult> {
    return this.send<EngineResult>('compute', { input, opts });
  }

  /** 比較ページの概算（標本減）。 */
  overview(input: FarmInput, opts?: ComputeOptions): Promise<EngineResult> {
    return this.send<EngineResult>('overview', { input, opts });
  }

  /** 保持プール上で任意 B の破産確率（標本は引き直さない）。 */
  ruinAt(B: number): Promise<number> {
    return this.send<number>('ruinAt', { B });
  }

  terminate(): void {
    this.worker.terminate();
  }
}
